import youburaLib from 'npawlib';
import RequiredProp from '../../shared/RequiredProp';
import {
  DEFAULT_EVENT,
  DEFAULT_SESSION,
  DEFAULT_NAVIGATION_EVENT,
  EMPTY_STRING,
} from '../../shared/constants';

const PROVIDER_NAME = 'Youbora Infinity';
const INFINITY_ENABLED = true;

class YouboraInfinity {
  constructor() {
    this.providerName = PROVIDER_NAME;
  }

  pluginInitialize(sessionProps = DEFAULT_SESSION) {
    const pluginConfig = {
      isInfinity: INFINITY_ENABLED,
      ...sessionProps,
    };

    const youbora = new youburaLib.Plugin(pluginConfig);
    this.appAnalytics = youbora.appAnalytics;
  }

  pluginStop() {
    this.appAnalytics.fireSessionStop();
  }

  fireEvent(eventProps = DEFAULT_EVENT) {
    const name = eventProps?.event || eventProps?.eventLabel || '';
    const { event, ...dimensions } = eventProps;

    this.appAnalytics.fireEvent(name, dimensions);
  }

  fireNav(navProps = DEFAULT_NAVIGATION_EVENT) {
    if (!navProps?.userType) throw RequiredProp('userType');
    if (!navProps?.country) throw RequiredProp('country');
    if (!navProps?.pageType) throw RequiredProp('pageType');

    const dimensions = {
      id: navProps?.id || EMPTY_STRING,
      user_type: navProps?.userType,
      country: navProps?.country,
      pageType: navProps?.pageType,
    };

    this.appAnalytics.fireNav(dimensions);
  }

  newSession(sessionProps = DEFAULT_SESSION) {
    if (!sessionProps?.accountCode) throw RequiredProp('accountCode');
    if (!sessionProps?.service) throw RequiredProp('service');

    const newSessionProps = {
      isInfinity: INFINITY_ENABLED,
      ...sessionProps,
    };

    this.appAnalytics.newSession(newSessionProps);
  }
}

export default YouboraInfinity;
